import { useHandleClickOutside } from '@/hooks/useHandleClickOutside'
import { Box, Text } from '@chakra-ui/react'
import type { PackageItemModel, PartPackage } from 'BrokerTsLib/src/dtos'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'
import { useRef, useState } from 'react'
import { CustomEditableControls } from './CustomEditableControls'
import { EditableContext } from './EditableTinySelect'
import { TinySelect } from './TinySelect'


type EditablePackageItemTinySelectProps = {
  part: PartPackage
  valueText?: string
  isDisabled?: boolean
  packageItem: PackageItemModel
  onSubmit: (limit: number, variantId?: number) => void
  isEditing?: boolean
  showControls?: boolean
  packageItemVariantId?: number
}

export const EditablePackageItemTinySelect = ({ packageItem, part, valueText, packageItemVariantId, onSubmit, isDisabled, isEditing: edditing = false, showControls = true }: EditablePackageItemTinySelectProps) => {
  const [isEditing, setIsEditing] = useState(edditing)

  const ref = useRef(null)
  useHandleClickOutside(ref, () => {
    setIsEditing(false)
  })

  return (
    <EditableContext.Provider value={{
      isEditing: isEditing,
      setIsEditing: setIsEditing
    }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {!isEditing &&
          <Text sx={{ p: 0, fontSize: 'sm' }}>{valueText}</Text>
        }
        {isEditing && <>
          <TinySelect ref={ref}
            isDisabled={isDisabled}
            onChange={(e) => {
              const dataset = e.target.options[e.target.selectedIndex].dataset
              onSubmit(parseInt(e.target.value), parseInt(dataset.id!))
              setIsEditing(false)
            }}
            value={(part.limit?.toString() ?? '') + '_' + (packageItemVariantId?.toString() ?? '')}
          >
            {packageItem.variants.map((option) => {
              if ((!option.defaultLimit && option.defaultLimit != 0) || !option.id) return null

              return (
                <option key={option.defaultLimit + option.id} value={option.defaultLimit.toString() + '_' + option.id.toString()} data-id={option.id} data-limit={option.defaultLimit}>
                  {option.limitText ? option.limitText : option.defaultLimit == 999999999 ? 'Neomezeně' : priceFormat(option.defaultLimit, null, '0 Kč')}
                </option>

              )
            })}
          </TinySelect>

        </>}
        {!isDisabled && showControls && <CustomEditableControls />}
      </Box>
    </EditableContext.Provider>
  )
}